console.log('run resize fix')
const iOSBrowser = /ip(hone|od|ad)/i.test(window.navigator.userAgent)
if (iOSBrowser) {
  const root = document.documentElement
  const resize = () => root.style.setProperty('--vh', `${window.innerHeight}px`)
  window.addEventListener('resize', resize, { passive: true })
  resize()
}
